export default {
  getJobListingStatus: (state) => state.jobListingStatus,
};
